var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"thumbnail-wrapper"},[_c('img',{staticClass:"thumbnail img-fluid",style:({height: _vm.imgContainerHeight + 'px'}),attrs:{"src":_vm.data.category_img_url,"alt":_vm.data.category_title}})]),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.data.category_title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }